const eighteenAppPayment = (state = false, action) => {
    switch(action.type) {
        case 'eighteenAppPayment':
            return action.payload;
        default:
            return state;
    }
}

export default eighteenAppPayment;